// Retorna a URL apenas se usar esquema http(s); caso contrário, undefined.
// Evita javascript:/data: em hrefs montados a partir de dados externos.
export const safeUrl = (url) =>
  typeof url === 'string' && /^https?:\/\//i.test(url) ? url : undefined;

export default safeUrl;
